<script setup>
import { ref, watchEffect } from 'vue';
import router from '@/router';
import { API } from '@/services/index';
import { CREATE_ACCOUNT } from '@/services/account/mutations/account/index.js';
import { useMutation } from '@tanstack/vue-query';
import { useSetupStore } from '@/stores/setup.store.js';

const setup = useSetupStore();
const nextPageHref = ref('');
const accountType = ref(null);
const accountTypeName = ref(null);
const companyName = localStorage.getItem('_pup_new_account_company_name') ? JSON.parse(localStorage.getItem('_pup_new_account_company_name')) : null;
const errors = ref(null);
const isLoading = ref(false);

// onBeforeMount(async () => {
//   if (setup.getNewAccount) {
//     await router.push(nextPageHref.value);
//   } else {
//     accountTypeName.value = setup.getAccountTypeName;
//     accountType.value = setup.getAccountType;
//   }
// });

watchEffect(() => {
  if (setup.getAccountType === 1) {
    nextPageHref.value = '/onboard/social-connect';
  } else {
    nextPageHref.value = '/onboard/invite-team';
  }
});

const selections = [
  {
    id: 'creator',
    type: 'Creator',
    type_name: 'Individual',
    title: 'Creator and/or Influencer',
    description: 'I want to grow my audience, engage with my fans, make money and win brand deals.'
  },
  {
    id: 'brand',
    type: 'Team',
    type_name: 'Team',
    title: 'Brand',
    description: 'I want to manage my projects, view creators, and keep my relationships and communication front of mind.'
  },
  {
    id: 'agency',
    type: 'Enterprise',
    type_name: 'agency',
    title: 'Agency',
    description: 'I want to manage my creators, communicated with clients, and make all aspects of the work flow as smooth as possible.'
  }
];

const updateSelected = (type, name) => {
  accountType.value = type;
  accountTypeName.value = name;
};

const createAccountHandler = async () => {
  isLoading.value = true;
  const payload = {
    name: companyName,
    type: accountType.value
  };
  createUserAccountMutation.mutateAsync(payload);
};

const createUserAccountMutation = useMutation({
  mutationFn: async (payload) => {
    return await API.sendQuery('/graphql/account', CREATE_ACCOUNT, payload);
  },
  onSuccess: (data) => {
    if (data.data.data.createAccount) {
      setup.setNewAccount(data.data.data.createAccount);
      // localStorage.setItem(
      //   '_pup_new_account',
      //   JSON.stringify({
      //     id: Number(data.data.data.createAccount.id),
      //     type: accountType.value,
      //     name: data.data.data.createAccount.name
      //   })
      // );

      // router.push(nextPageHref.value);
      router.push('Home'); // push to Home for now.
    }
    if (data.data.errors) {
      errors.value = data.data.errors;
    }
  },
  onError: (error) => {
    console.log('error', error);
    errors.value = 'System error. Please try again later.';
  }
});
</script>

<template>
  <div>
    <div class="tw-text-center">
      <h3 class="tw-font-mono tw-text-lg tw-font-bold tw-text-primary-blue">Tell us about yourself.</h3>
      <div class="tw-text-[0.8rem]">Your choice here won’t limit what you can do.</div>
    </div>
    <div class="tw-mt-5">
      <template v-for="option in selections" :key="option.id">
        <v-hover>
          <template v-slot:default="{ isHovering, props }">
            <v-card
              :disabled="isLoading"
              v-bind="props"
              class="tw-mb-5 tw-rounded-lg tw-p-4"
              :color="isHovering || accountType === option.type ? 'primary-blue' : 'undefined'"
              style="box-shadow: 0px 3px 6px #00000029; cursor: pointer"
              @click="updateSelected(option.type, option.type_name)"
            >
              <div class="tw-my-1">
                <div class="tw-text-left tw-text-base tw-font-bold">
                  {{ option.title }}
                </div>
                <div class="tw-text-left tw-text-sm">
                  {{ option.description }}
                </div>
              </div>
            </v-card>
          </template>
        </v-hover>
      </template>
    </div>
    <div class="tw-w-full">
      <v-btn
        color="primary-blue"
        size="large"
        rounded="lg"
        block
        flat
        class="tw-font-bold tw-capitalize"
        style="letter-spacing: 0px"
        @click="createAccountHandler"
        :loading="isLoading"
        :disabled="isLoading || accountType === null"
      >
        Continue to Your Dashboard
      </v-btn>
      <div class="tw-my-5">
        <v-progress-linear class="tw-mt-4" color="primary-blue" model-value="25"></v-progress-linear>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
